/*
 *  Vue Router
 *
 * */
import Vue from 'vue';
import VueRouter from 'vue-router';

// Pages

const HomePage = require('./pages/HomePage.vue');
const YearPage = require('./pages/YearPage.vue');
const BookPage = require('./pages/BookPage.vue');
const StatementPage = require('./pages/StatementPage.vue');
const PartnersPage = require('./pages/PartnersPage.vue');
const ContactPage = require('./pages/ContactPage.vue');
const SupportPage = require('./pages/SupportPage.vue');
const PageNotFound = require('./pages/PageNotFound.vue');

Vue.use(VueRouter);

const BlankComponent = {template:'<div></div>'};

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
  },
  {
    path: '/:year(2017|2018|2019|2020|2021|2022|2023|2024|2025)',
    name: 'year',
    component: YearPage,
  },
  {
    path: '/:year(2017|2018|2019|2020|2021|2022|2023|2024|2025)/:book',
    name: 'book',
    component: BookPage
  },
  {
    path: '/statement',
    name: 'statement',
    component: StatementPage
  },
  {
    path: '/partners',
    name: 'partners',
    component: PartnersPage
  },
  {
    path: '/support',
    name: 'support',
    component: SupportPage
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactPage
  },
  { path: '/the-distance-plan-4', redirect: '/2017/the-distance-plan-4' },
  { path: '/lanx-satura', redirect: '/2017/lanx-satura' },
  { path: '/laurel-doody-may-28-2016', redirect: '/2017/laurel-doody-may-28-2016' },
  { path: '/incredible-feeling', redirect: '/2017/incredible-feeling' },
  { path: '/supple-mental', redirect: '/2017/supple-mental' },
  { path: '/personal-address', redirect: '/2017/personal-address' },
  { path: '/next-spring-an-occasional-series-of-reviews-no-1-paris-may-16', redirect: '/2017/next-spring-an-occasional-series-of-reviews-no-1-paris-may-16' },
  { path: '/prism-of-reality', redirect: '/2017/prism-of-reality' },
  { path: '/neotropico', redirect: '/2017/neotropico' },
  { path: '/purity-live-in-los-angeles', redirect: '/2017/purity-live-in-los-angeles' },
  { path: '/volume', redirect: '/2017/volume' },
  { path: '/routine-pleasures', redirect: '/2017/routine-pleasures' },
  { path: '/routine-pleasures', redirect: '/2017/routine-pleasures' },
  {
    path: '*',
    name: 'pageNotFound',
    component: PageNotFound
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;


// WEBPACK FOOTER //
// ./resources/js/router.js